module.exports = __webpack_public_path__ + "img/bigualu.5ad85df8.png";